import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import fr from './fr.json';
import en from './en.json';

const savedLang = localStorage.getItem('wl_lang') || 'fr';

i18n
  .use(initReactI18next)
  .init({
    resources: { fr: { translation: fr }, en: { translation: en } },
    lng: savedLang,
    fallbackLng: 'fr',
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });

export async function changeLanguage(lang: 'fr' | 'en'): Promise<void> {
  localStorage.setItem('wl_lang', lang);
  await i18n.changeLanguage(lang);
}

export default i18n;
